import React, { useContext, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import AdvancedSearchDropdown from '../../../components/dropdown';

import { AdvancedSearchShipmentContext } from '../../context';
import { id } from '../../../../filters/options/fulfillment-type';
import { fulfillmentTypeOptions } from '../../../../filters/options/fulfillment-type/options';
import messages from '../messages';

import baseStyle from '../../../style.module.less';

const FulfillmentTypeFilter = () => {
  const { filters, updateFilter } = useContext(AdvancedSearchShipmentContext);

  const { value = '' } = filters.find((filter) => filter.id === id) || [];
  const fulfillmentType = fulfillmentTypeOptions.find((opt) => opt.apiKey === value) || {};

  const onOptionSelected = useCallback(
    (option) => {
      updateFilter(id, option.apiKey);
    },
    [updateFilter],
  );

  return (
    <span className={baseStyle.filterInput}>
      <label className={baseStyle.filterLabel}>
        <FormattedMessage {...messages.fulfillmentType} />
      </label>
      <AdvancedSearchDropdown onOptionSelected={onOptionSelected} options={fulfillmentTypeOptions} selectedId={fulfillmentType.id} />
    </span>
  );
};

export default FulfillmentTypeFilter;
